<nz-alert *ngIf="showError" class="card"
	nzType="error" nzShowIcon
	nzMessage="{{ alertMessage | translate }}"
></nz-alert>
<nz-alert *ngIf="showWarning" class="card"
	nzType="warning" nzShowIcon
	nzMessage="{{ alertMessage | translate }}"
></nz-alert>

<div *appIfPermission="['users:read', 'project-users:read']; some: true" nz-row [nzJustify]="'end'" [nzGutter]="[16, 6]" class="mb-2">
	<div nz-col>
		<app-splitbutton *ngIf="resolvedSchema && data" [elements]="[userRoleButton]"></app-splitbutton>
	</div>
</div>

<ng-container *ngIf="resolvedSchema && data">
	<app-form-schema-renderer *appIfPermission="'users:write'; else: readonly"
		[property]="[]" [schema]="resolvedSchema" [data]="data" [readonly]="false"
		(emitFormSubmit)="editUser($event)" [formID]="userFormID"
		(emitFormValid)="setSubmitActive($event)"
	></app-form-schema-renderer>
	<ng-template #readonly>
		<app-form-schema-renderer [property]="[]" [schema]="resolvedSchema" [data]="data" [readonly]="true" [formID]="userFormID"></app-form-schema-renderer>
	</ng-template>
</ng-container>

<div nz-row [nzJustify]="'space-between'">
	<div nz-col>
		<div nz-row [nzGutter]="[16, 6]">
			<div nz-col>
				<app-splitbutton [elements]="[userCancelSplitButton]"></app-splitbutton>
			</div>
			<ng-container *ngIf="data && !isSameUser">
				<div nz-col *appIfPermission="'users:delete'">
					<app-splitbutton [elements]="[userDeleteSplitButton]"></app-splitbutton>
				</div>
			</ng-container>
		</div>
	</div>
	<div *appIfPermission="'users:write'" nz-col>
		<div nz-row [nzJustify]="'end'" [nzGutter]="[16, 6]">
			<div nz-col>
				<app-splitbutton *ngIf="resolvedSchema && data"
					[elements]="[userEditSplitButton]"
				>
				</app-splitbutton>
			</div>
		</div>
	</div>
</div>

<nz-modal
	[nzMaskClosable]="false"
	nzTitle="{{ 'user.delete.modal.title' | translate:{username: user?.username} }}"
	(nzOnOk)="deleteUser()"
	(nzOnCancel)="closeDeleteUserModal()"
	[nzVisible]="deleteModalVisible"
	nzOkText="{{ 'actions.OK' | translate }}"
	nzCancelText="{{ 'actions.cancel' | translate }}"
>
	{{ 'user.delete.modal.text' | translate:{ username: user?.username } }}
</nz-modal>
